import { Columns } from '../../../widgets/columns';
import React, { FC } from 'react';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';
import styled from 'styled-components';

const Container = styled.div`
    padding: 20px;
    width: 100%;
    align-self: flex-start;
`;

const SkeletonCard = styled.div`
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.app.borderColor};
    overflow: hidden;
`;

const SkeletonPreview = styled.div`
    aspect-ratio: 1;
`;

const SkeletonInfo = styled.div`
    padding: 12px;
`;

export const AssetCardSkeleton: FC = () => {
    return (
        <SkeletonCard aria-hidden='true'>
            <SkeletonPreview>
                <SkeletonBlock $height='100%' $radius='0' />
            </SkeletonPreview>
            <SkeletonInfo>
                <SkeletonStack $gap='10px'>
                    <SkeletonBlock $width='80%' $height='14px' />
                    <SkeletonBlock $width='50%' $height='12px' />
                </SkeletonStack>
            </SkeletonInfo>
        </SkeletonCard>
    );
};

export const AssetGridSkeleton: FC = () => {
    return (
        <Container>
            <Columns $xs={2} $md={3} $lg={8} $gap={20}>
                {Array.from({ length: 8 }).map((_, index) => (
                    <AssetCardSkeleton key={index} />
                ))}
            </Columns>
        </Container>
    );
};
